import { gql } from '@apollo/client';

export const deleteBalancingPointAssetMutation = gql`
  mutation DeleteBalancingPointAsset($balancingPointId: ID!) {
    ekaDeleteBalancingPoint(balancingPointId: $balancingPointId) {
      __typename
    }
  }
`;
